import { ProductFilterOptionInterface, ProductFilterOptionTitles } from '../models/ProductFilterOptionInterface';
import { RestrictionTypes } from '@client-monorepo/common/network';

export const ProductFilterOptionsConst: ProductFilterOptionInterface[] = [
  {
    title: ProductFilterOptionTitles.PRICE,
    type: RestrictionTypes.RANGE,
    field: 'price',
    minValue: 1000,
    maxValue: 100000000000,
    rangeMin: 1000,
    rangeMax: 100000000000,
  },
];
